import { useEffect, useRef, useLayoutEffect, useState } from "react";
import {
  Vector,
  Events,
  Mouse,
  Body,
  Matter,
  Engine,
  World,
  Render,
  Bodies,
  Composite,
} from "matter-js";
import Fruits from "./Fruits";

function NetworkEffect({containerRef}) {
  const sceneRef = useRef(null);
  const isPressed = useRef(false);
  const engineRef = useRef(null);
  const mouseRef = useRef(null);
  const renderRef = useRef(null);


  const nodeRadius = 6;

  var defaultCategory = 0x0001; // for walls

  const [hasClicked, setClicked] = useState(false);
  const [showWireframes, setShowWireframes] = useState(false);
  const [isHovering, setHovering] = useState(false);
  const [canDrop, setCanDrop] = useState(true);
  const fruitCooldown = 0.2;

  const [containerSize, setContainerSize] = useState({width:600, height:600});
  const [scale, setScale] = useState(1);


  const wallRefs = useRef(null);
  const wallThickness = 30

  const resizingDelayTimer = useRef(null);

  const tryMaxHeight = 600;

  //wall stuff
  var wallOptions = {
    collisionFilter: {
      category: defaultCategory,
    },
    isStatic: true,
  };

  

  const createWalls = (containerWidth, containerHeight) => {
    let walls = [
          // Top
          Bodies.rectangle(
            containerWidth / 2,
            (-wallThickness / 2),
            containerWidth,
            wallThickness,
            wallOptions
          ),
          // Bottom
          Bodies.rectangle(
            containerWidth / 2,
            containerHeight + wallThickness / 2,
            containerWidth,
            wallThickness,
            wallOptions
          ),
          // Left
          Bodies.rectangle(
            -wallThickness / 2,
            containerHeight / 2,
            wallThickness,
            containerHeight,
            wallOptions
          ),
          // Right
          Bodies.rectangle(
            containerWidth + wallThickness / 2,
            containerHeight / 2,
            wallThickness,
            containerHeight,
            wallOptions
          ),
        ];
          walls[0].name = "TOP";
  walls[1].name = "BOT";
  walls[2].name = "LEFT";
  walls[3].name = "RIGHT";
  walls.forEach((element) => {
    element.objectType = "WALL";
  });
        wallRefs.current = walls;
    Composite.add(engineRef.current.world, walls);
  };


  const addRandomNode = () => {
    // let width = containerRef?.current.getBoundingClientRect()?.width;
    // let height = containerRef?.current.getBoundingClientRect()?.height;
   let width = 600;
    let height = 600;
    let randomRadius =  nodeRadius + (-1 + (Math.random() * 8));
      let randomX = (nodeRadius*2) +  Math.random() * (width - nodeRadius *2);
      let randomY = (nodeRadius*2) +  Math.random() * (height - nodeRadius *2);
      Composite.add(engineRef.current.world, [
      createNodeBody(randomX, randomY, randomRadius),
    ]);
  }

   // Observe size changes of the container
      useEffect(() => {
        if (!containerRef?.current || !engineRef) return;
        const updateSize = (w, h) => {
        if(!w)return;
        let newW = w;
        let newH = h;
        let wRatio = newW/newH;
        let currentw = tryMaxHeight * wRatio;
        let scale = newW/currentw;
        setScale(scale);
        setContainerSize({
          width: currentw,
          height: tryMaxHeight
        });
        if(wallRefs?.current){
          wallRefs.current?.forEach(wall => World.remove(engineRef.current.world, wall));
        createWalls(currentw + 10, tryMaxHeight);
        }
        
      };
     const resizeObserver = new ResizeObserver(() => {
          let width = containerRef?.current?.getBoundingClientRect()?.width ?? 10;
        let height = containerRef?.current?.getBoundingClientRect()?.height ?? 10;
      updateSize(width,height);

    });


    resizeObserver.observe(containerRef?.current);

    // Set initial size
    updateSize(containerRef?.current.getBoundingClientRect()?.width ?? 10, containerRef?.current.getBoundingClientRect()?.height ?? 10);

    return () => {
      resizeObserver.disconnect();
    };
      }, [containerRef]);



      useEffect(() => {
        if(!renderRef?.current)
          return;
    // Update canvas and viewport
    if(containerSize?.width == null || containerSize?.height == null || renderRef.current.canvas?.width == null){
      return;
    }
    renderRef.current.canvas.width = containerSize?.width;
    renderRef.current.canvas.height = containerSize?.height;
      }, [containerSize]);

  useEffect(() => {

    // Clean up the existing engine before creating a new one
    if (engineRef.current) {
      Composite.clear(engineRef.current.world, true);
      Engine.clear(engineRef.current);
    }

    const newEngine = Engine.create();
    engineRef.current = newEngine;

    let engine = engineRef.current;
    let composite = engine.world;
    let scene = sceneRef.current;
    let fruitsToAdd = [];
    

    engine.gravity.scale = 0;


    renderRef.current = Render.create({
          element: scene,
          engine: engine,
          options: {
            width: 400,
            height: tryMaxHeight,
            wireframes: showWireframes,
            showCollisions: true,
          },
        })
      ;



    // mouseRef.current = Mouse.create(renderRef.current.canvas);
    const canvas = renderRef.current.canvas;
    const context = canvas.getContext("2d");

   
     createWalls(405, tryMaxHeight);

    

    setTimeout(() =>{
      for(let i = 0; i < 15; i++){
      addRandomNode();
    }
    }, 500)
    

    const handleNodeWallCollision = (bodyA, bodyB) => {
      let node;
      let wall;
      if (bodyA.objectType == "NODE") {
        node = bodyA;
        wall = bodyB;
      } else {
        node = bodyB;
        wall = bodyA;
      }
      if (wall.name == "TOP" || wall.name == "BOT") {
        Body.setVelocity(node, { x: node.velocity.x, y: -node.velocity.y });
      } else {
        Body.setVelocity(node, { x: -node.velocity.x, y: node.velocity.y });
      }

      return;
    };


    const handleCollisionStart = (event) => {
      let pairs = event.pairs;
      let alreadyProcessedIds = [];
      for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i];
        // Check if the collision involves circle bodies
        if (
          (pair.bodyA.objectType == "WALL" &&
            pair.bodyB.objectType == "NODE") ||
          (pair.bodyA.objectType == "NODE" && pair.bodyB.objectType == "WALL")
        ) {
          handleNodeWallCollision(pair.bodyA, pair.bodyB);
        }
      }
    }
    Events.on(engine, "collisionStart", handleCollisionStart);



    function calculateDistance(x1, y1, x2, y2) {
      return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    }
    let drawLineBetweenPoints = (bodyA, bodyB) => {
      //check if they should be drawing.
      let distanceBetween = calculateDistance(
        bodyA.position.x,
        bodyA.position.y,
        bodyB.position.x,
        bodyB.position.y
      );
      if (distanceBetween < 300) {
        const transparency = Math.max(1 - distanceBetween / 300, 0);
        context.beginPath();
        context.moveTo(bodyA.position.x, bodyA.position.y);
        context.lineTo(bodyB.position.x, bodyB.position.y);
        context.strokeStyle = `rgba(255, 255, 255, ${transparency})`;
        context.lineWidth = 2;
        context.stroke();
        return;
      }
    };
    let renderCanvass = () => {
      // Iterate through all bodies in the world
      const fruits = [];
      for (let i = 0; i < composite.bodies.length; i++) {
        if (composite.bodies[i].objectType == "NODE") {
          fruits.push(composite.bodies[i]);
        }
      }
      for (let i = 0; i < fruits.length - 1; i++) {
        let bodyA = fruits[i];
        for (let j = i + 1; j < fruits.length; j++) {
          let bodyB = fruits[j];
          drawLineBetweenPoints(bodyA, bodyB);
        }
      }
    };

    // Composite.add(engine.current.world);
const FIXED_TIME_STEP = 1000 / 60; // 16.666ms
let lastTime = performance.now();
let isRunning = true;
let animationFrameId;

function update(currentTime) {
  if (!isRunning) {
    animationFrameId = requestAnimationFrame(update); // keep the loop alive
    return;
  }
  let delta = currentTime - lastTime;

  // Cap delta to prevent big jumps on resume
  delta = Math.min(delta, 100); // don't process more than ~6 frames worth

  // Run fixed timestep updates (can run multiple steps per frame if needed)
  while (delta >= FIXED_TIME_STEP) {
    Engine.update(engine, FIXED_TIME_STEP);
    delta -= FIXED_TIME_STEP;
    lastTime += FIXED_TIME_STEP;
  }

  if (scene) {
            try {
              Render.world(renderRef.current);
              renderCanvass();
              //applyRainbowOverlay();
            } catch (e) {
              console.log("E ERRRROR");
              console.log(e);
            }
          }

  animationFrameId = requestAnimationFrame(update);
}
    animationFrameId = requestAnimationFrame(update);
    
    const handleVisibilityChange = () => {
      if (document.hidden) {
    isRunning = false; // Pause the simulation
  } else {
    isRunning = true;
    lastTime = performance.now(); // Reset time to avoid jump
  }
    }
// Handle tab visibility
document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      Events.off(engine, "collisionStart", handleCollisionStart);
      cancelAnimationFrame(animationFrameId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      Render.stop(renderRef.current);
      Composite.clear(newEngine.world);
      Engine.clear(newEngine);
      if (renderRef.current) {
        renderRef.current.canvas.remove();
        renderRef.current.canvas = null;
        renderRef.current.context = null;
        renderRef.current.textures = {};
      }
    };
  }, []);


  const handleDown = (e) => {
    isPressed.current = true;
    if (hasClicked === false) {
      setClicked(true);
      // handleAddCircle(e);
    }
  };

  const handleUp = () => {
    isPressed.current = false;
    if (hasClicked === true) {
      setClicked(false);
    }
  };
  const handleMatterEnter = () => {
    setHovering(true);
  };
  const handleMatterLeave = () => {
    setHovering(false);
  };

  const createNodeBody = (x, y, radius = nodeRadius) => {
    const ball = Bodies.circle(x, y, radius, {
      mass: 0,
      frictionAir: 0,
      restitution: 0,
      friction: 0,
      render: {
        fillStyle: "white",
      },
      collisionFilter: {
        group: -1, // Set a negative group to avoid collisions with other bodies
        category: 0x0001,
        mask: 0x0001,
      },
    });
    ball.objectType = "NODE";
    Body.setVelocity(ball, {
      x: -2 + Math.random() * 4,
      y: -2 + Math.random() * 4,
    });
    // ball.ignoreGravity = true;
    return ball;
  };


  const handleClear = () => {
    Composite.clear(engineRef.current.world);
    createWalls(containerRef?.current.getBoundingClientRect()?.width ?? 600, containerRef?.current.getBoundingClientRect()?.height ?? 600);
  };
  const handleStatus = () => {
    console.log("bodies count: " + engineRef.current.world.bodies.length);
  };


  return (
<div className="relative h-full">
      <div
        ref={sceneRef}
        style={{
        width: `${containerSize.width}px`,
        height: `${containerSize.height}px`,
        overflow: "hidden",
        background: "#f0f0f0",
        transform: `translate(-50%, -50%) scale(${scale})`
      }}
      className={`rounded-xl absolute left-1/2 top-1/2`}
         />
      <div 
      style={{ width: `${containerSize.width}px`,
        height: `${containerSize.height}px`,
       transform: `translate(-50%, -50%) scale(${scale})` }} 
        className="absolute left-1/2 top-1/2 w-full h-full backdrop-blur pointer-events-none rounded-xl" />
    </div>
  );
}

export default NetworkEffect;
